module.exports = __webpack_public_path__ + "img/icon_map_2_off_111.1ea10d11.png";